import script from "./Payment.vue?vue&type=script&lang=ts&setup=true"
export * from "./Payment.vue?vue&type=script&lang=ts&setup=true"

import "./Payment.vue?vue&type=style&index=0&id=2197c3ad&lang=less&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2197c3ad"]])

export default __exports__